// extracted by mini-css-extract-plugin
export default {"filtersBox":"styles_filtersBox__Vdfmo","bookletProfileSection":"styles_bookletProfileSection__yhs3B"};